import Tickets from "./Tickets";
import TicketsProvider from "./TicketsContext";

let Index = () => {

    return (
        <TicketsProvider>
            <Tickets />
        </TicketsProvider>
    );
}

export default Index;